export default "__VITE_ASSET__e9550d89__"